import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Radio } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Header / court-board CTA — lights up red whenever a Twitch channel or Main Court is configured
export default function WatchLiveButton({ className = "", compact = false }) {
  const [live, setLive] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${API}/public/live`).then(({ data }) => setLive(data)).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);
  const on = !!(live?.twitch_channel || live?.main);
  return (
    <Link to="/live" data-testid="watch-live-btn" title={on ? "Watch the live stream" : "Live page"}
      className={`inline-flex items-center gap-1.5 border px-2.5 py-1.5 text-[10px] font-black uppercase tracking-widest transition-colors ${on ? "border-red-500/70 text-red-400 hover:bg-red-500 hover:text-white" : "border-pb-border text-zinc-500 hover:text-white"} ${className}`}>
      <span className="relative flex h-2.5 w-2.5">
        {on && <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping" />}
        <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${on ? "bg-red-500" : "bg-zinc-600"}`} />
      </span>
      <Radio className={`w-3.5 h-3.5 ${on ? "animate-pulse" : ""}`} />
      {!compact && <span>Watch Live</span>}
    </Link>
  );
}
